// extracted by css-extract-rspack-plugin
var _1 = "wB9GnsIj4o8iCjIz";
var _2 = "Uh4oZI59hmoly1II";
var _3 = "CCOhyGC3sr6sxefg";
export { _1 as "fade-in", _2 as "fullscreen", _3 as "xs" }
// extracted by css-extract-rspack-plugin
var _1 = "wB9GnsIj4o8iCjIz";
var _2 = "Uh4oZI59hmoly1II";
var _3 = "CCOhyGC3sr6sxefg";
export { _1 as "fade-in", _2 as "fullscreen", _3 as "xs" }
